var helperMixin = {
  methods: {
    checkIsMobile: function () {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    },
    buttonAsHref: function (path) {
      window.location = path;
    }
  }
}

export default {
  mixins: [helperMixin]
}